<template>
  <div id="loseDataEcharts">
    <div id="progressEcharts" ref="progressEcharts"></div>
    <div class="PieEchartsBox">
      <div id="PieEcharts" ref="PieEcharts"></div>
        <div class="nodata_box" v-if="Judge">
          <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
          <span>暂无数据</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:['LoseProjectSourceDataList','LoseProjectTypeDataList','screenWidth'],
    data() {
        return {
            ProgressData:'', // 项目来源数据
            progressLsit:[], // 个数
            Judge:''
        };
    },
    mounted(){  
    },    
    methods:{
       //  进度条 项目来源    
       initChart2(){
      let Chart1 = this.$echarts.getInstanceByDom(this.$refs.progressEcharts);
      if (Chart1 == null) {
        this.myChart1 = this.$echarts.init(this.$refs.progressEcharts);
      }
        const option = {
            textStyle: {
              fontFamily: 'PingFang-M'
            },
            title: {
            text: '项目来源',
            top:'24',  
            left:this.$route.query.identification ? '20' : '30',
              textStyle:{
                fontWeight:500,
              }
            }, 
            tooltip:{
              show:true,
              trigger:'item',
              formatter:params=>{
              let string = `<div style="padding:4px;">
                              <div>${params.name}：${this.ProgressData[params.dataIndex]}个</div>
                              <div>占比：${params.value}%</div>
                            </div>
                          `
                          return string
              }
            },          
            grid: {
                left:this.$route.query.identification ? '25' : '40',
                right:this.$route.query.identification ? '15' : '46',
                bottom:this.$route.query.identification ?'18' : '35',
                top: this.$route.query.identification ? '55' : '55',
            },
            xAxis: {
                show: false,
                type: 'value'
            },
            yAxis: [{
                type: 'category',
                inverse: true,       
                axisLabel: {
                    formatter: (val,index)=>{
                      let res =  '';
                     this.ProgressData.forEach((item,i)=>{
                        if( i == index) {
                          res = item
                        }
                      })
                      return val + `（${res}个）`
                    },
                    textStyle: {
                        color: '#666666',
                        fontSize: '14',
                        lineHeight:20,
                    },
                    padding:[0,0,35,10],
                    align:'left',
                    rich: {}
                },
                splitLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                data: this.LoseProjectSourceDataList.yAxis.data
            }, {
                type: 'category',
                inverse: true,
                axisTick: 'none',
                axisLine: 'none',
                position:'left',
                show: true,
                axisLabel: {
                    textStyle: {
                        color: '#57b9ff',
                        fontSize: '14'
                    },
                    padding:[0,0,-45,10],
	        		      formatter: '{value}%',
                    align:'left',
                    rich: {}
                },
                data:this.LoseProjectSourceDataList.series[0].percent
            }],
            series: [{
                    type: 'bar',
                    zlevel: 1,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 10,
                            color: '#57b9ff'
                        },
                    },
                    barWidth: 10,
                    data: this.LoseProjectSourceDataList.series[0].percent,
                },
                {
                    name: '背景',
                    type: 'bar',
                    silent: true,
                    barWidth: 10,
                    barGap: '-100%',
                    data: this.progressLsit,
                    itemStyle: {
                        normal: {
                            color: '#eeeeee',
                            barBorderRadius: 10,
                        }
                    },
                },
                
            ]
         };
         this.myChart1.setOption(option);
          window.addEventListener("resize", () => {
          if(this.$route.query.identification) {
            var resize = {
              width: this.screenWidth -21,
            };
            this.myChart1.resize(resize);
          } else {
            this.myChart1.resize();
          }
        }); 
       },
       //  饼状图  项目类型    
       initChart3(){
          let JudgeConditions = this.$route.query.identification
          let Chart2 = this.$echarts.getInstanceByDom(this.$refs.PieEcharts);
          if (Chart2 == null) {
            this.myChart2 = this.$echarts.init(this.$refs.PieEcharts);
          }        
          const option = {
                  textStyle: {
                    fontFamily: 'PingFang-M'
                  },
                  title: {
                    text: '项目类型',
                    top:'24',  
                    left:this.$route.query.identification ? '20' : '30',
                      textStyle:{
                        fontWeight:500,
                      }
                  },
                   tooltip: {
                    show:this.$route.query.identification ? true : (this.screenWidth <=1366 ? true : false) , 
                    trigger: 'item',      
                    formatter:params=>{
                      return `<div style="font-size:14px; padding:4px;">
                                  <div>${params.name}：${params.data.value}个</div>
                                  <div>占比：${params.data.percent}%</div>
                              </div>`
                   }
                  },
                  color:["#59b9fe", "#62d8ae","#ffb971"],
                  legend: {
                    orient:this.$route.query.identification ? "horizontal" : "vertical",
                    x:this.$route.query.identification ?  '120':'35',
                    y:this.$route.query.identification ? '24' : '70',
                    itemGap:this.$route.query.identification ? 30 : 14,
                    itemWidth: 10,
                    itemHeight: 11,
                    data:this.LoseProjectTypeDataList,
                    formatter: (name)=>{
                          return name
                    },
                    textStyle: {
                        color: '#646464',
                        height: 10,
                        rich: {
                          a: {
                            verticalAlign: 'middle',
                        },
                      }
                    },
                  },
                  series: [
                    {
                      name: '项目类型',
                      type: 'pie',
                      stillShowZeroSum:false,
                      radius:this.$route.query.identification ? ['40%','60%'] : (this.screenWidth <= 1366 ? ['40%','60%'] : ['45%', '60%']),
                       center:this.$route.query.identification ? ['50%','55%'] : (this.screenWidth <= 1366 ? ['55%','50%'] : ['50%','50%']) ,
                      silent:this.$route.query.identification ? false : (this.screenWidth <= 1366 ? false : true) , // 鼠标悬浮高亮
                      itemStyle: {
                        align:'left',
                          normal: {
                          borderWidthLeft: this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : 1) ,
                          borderColor:this.$route.query.identification ? 'none' : (this.screenWidth <=1366 ? 'none' : '#fff') ,
                            label: {
                              show:this.Judge ? false : true,
                              align:'left',
                              position:this.$route.query.identification ? 'inside' : (this.screenWidth <=1366 ? 'inside' : 'outside') ,
                              padding:[15,0,0,0],
                              fontSize:this.$route.query.identification ? 15 : 12,
                              formatter: params => {
                                if(JudgeConditions == 'pplet' || this.screenWidth <=1366){
                                    return params.data.percent == 0 ? '' : `${params.data.percent}%`
                                }else{
                                    return `{left|\n${params.data.name}：${params.data.value}个\n占比：${params.data.percent}%\n}`
                                }
                              },
                              rich: {
                              left: {
                                  align:'left',
                                  lineHeight:15,
                                  color:'#666666'
                              }
                              },                           
                            },
                          },

                      },
                      labelLine:{
                        normal:{
                          show:this.Judge ? false : true,
                          length:this.$route.query.identification ? 5 : (this.screenWidth <= 1366 ? 10 : 20),
                          length2:this.$route.query.identification ? 20 : (this.screenWidth <= 1366 ? 30 : 45),
                        }
                      },
                      data: this.LoseProjectTypeDataList,
                    }
                  ]
              };
            this.myChart2.setOption(option);
            window.addEventListener("resize", () => {
              if(this.$route.query.identification) {
                var resize = {
                  width: this.screenWidth -21,
                };
                this.myChart2.resize(resize);
              } else {
                this.myChart2.resize();
              }
         }); 
        }
    },
    watch:{    
        //  项目来源   
        LoseProjectSourceDataList(val){
         for(let i = 0;i < val.series[0].data.length;i++){
            this.progressLsit.push(100)
         }
         this.ProgressData = val.series[0].data
         this.$nextTick(function () {
           var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
           window.dispatchEvent(myEvent); // 事件可以在任何元素触发
         })         
         this.initChart2();   
        },
        // 项目类型
        LoseProjectTypeDataList(val){
          const res = val.every(item=>{
            if(item.value==0) return true
          })
          this.Judge = res
         this.$nextTick(function () {
           var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
           window.dispatchEvent(myEvent); // 事件可以在任何元素触发
         })          
         this.initChart3();
        },
    }
}
</script>

<style lang="scss" scoped>
#loseDataEcharts{
    display: flex;
    margin-top: 0.24rem;
    #progressEcharts{
        height: 3.9rem;
        width: 50%;
        margin-right: 0.12rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius:0.1rem;
    }
    .PieEchartsBox{
      position: relative;
      height: 3.9rem;
      margin-left: 0.12rem;
      width: 50%;
      #PieEcharts{
          width:100%;
          height: 100%;
          background-color: #fff;
          -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          border-radius:0.1rem;        
      }
      .nodata_box{
        position: absolute;
        top: 0.26rem;
        left: 47%;
        height: 342px;
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
        span{
          font-size: 16px;
          color: #ccc;
          line-height: 44px;
        }
      }  
    }
}
@media screen and (max-width: 768px){
  #loseDataEcharts{
    flex-direction: column;
    padding: 0 0.12rem;
    margin-top: 0.12rem;
    .PieEchartsBox{
      width: 100%;
      margin-left: 0;
      .nodata_box{
        left: 40%;
      }
      #PieEcharts{
      margin-top: 0.12rem;
      background-color: #fff !important;
      border: none;
      width: 100%;
      margin-right: 0;
      margin-left: 0;
    }
    }
    #progressEcharts{
      background-color: #fff !important;
      border: none;
      width: 100%;
      height: 2.9rem;
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// loseDataEcharts.vue?ff143942